import { render } from "./Item8.vue?vue&type=template&id=7b7d77a5"
import script from "./Item8.vue?vue&type=script&lang=ts"
export * from "./Item8.vue?vue&type=script&lang=ts"
script.render = render

export default script